import { Chip } from "@mui/material";

interface GuestOrderingBadgeProps {
  enabled: boolean;
}

export const GuestOrderingBadge = ({ enabled }: GuestOrderingBadgeProps) => (
  <Chip
    size="small"
    label={enabled ? "Guest Ordering Enabled" : "Guest Ordering Disabled"}
    color={enabled ? "success" : "default"}
    sx={{ mt: 1 }}
  />
);
